import { CommonClubOperationsRoutingModule } from './common-club-operations-routing.module';
import { CommonClubOperationsComponent } from './common-club-operations.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
// import { CommonPullupMenuRoutingModule } from './common-pullup-menu-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CommonClubOperationsRoutingModule,
  ],
  declarations: [CommonClubOperationsComponent],
})
export class CommonClubOperationsModule {}
